import { useState, useRef } from 'react';

const useMessageGestures = ({
    screens,
    isRtl,
    shouldShowOnRight,
    canReplyToThis,
    onReplyAction,
    message
}) => {
    const [translateX, setTranslateX] = useState(0);
    const touchStartX = useRef(null);

    const handleTouchStart = (e) => {
        // Swipe to reply logic
        if (screens?.xs && e.touches && e.touches[0]) {
            touchStartX.current = e.touches[0].clientX;
        }
    };

    const handleTouchMove = (e) => {
        if (!screens?.xs || !touchStartX.current) return;

        const currentX = e.touches[0].clientX;
        const diff = currentX - touchStartX.current;

        // Determine allowed direction based on visual side
        // LTR + Right(User) -> Swipe Left (diff < 0)
        // LTR + Left(Agent) -> Swipe Right (diff > 0)
        // RTL + Left(User) -> Swipe Right (diff > 0)
        // RTL + Right(Agent) -> Swipe Left (diff < 0)

        const isVisualRight = (!isRtl && shouldShowOnRight) || (isRtl && !shouldShowOnRight);

        let allowed = false;
        if (isVisualRight && diff < 0) allowed = true;
        if (!isVisualRight && diff > 0) allowed = true;

        if (allowed) {
            // Limit drag distance
            if (Math.abs(diff) < 100) {
                setTranslateX(diff);
            }
        }
    };

    const handleTouchEnd = () => {
        // Trigger Reply if threshold met
        if (Math.abs(translateX) > 60) {
            if (canReplyToThis && typeof onReplyAction === 'function') {
                onReplyAction(message);
                if (navigator.vibrate) navigator.vibrate(50);
            }
        }

        setTranslateX(0);
        touchStartX.current = null;
    };

    const handleTouchCancel = () => {
        setTranslateX(0);
        touchStartX.current = null;
    };

    return {
        translateX,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
        handleTouchCancel
    };
};

export default useMessageGestures;
